"use client";

import React from "react";
import { Activity, Headset, MonitorPlay } from "lucide-react";
import { useRevealOnScroll } from "@/hooks/useRevealOnScroll";
const pillars = [{
  id: "01",
  title: "Arriendo Flexible",
  description: "Ofrecemos contratos de arriendo desde 1 mes en adelante, adaptándonos a los ciclos de su cosecha o proyecto.",
  iconName: "Activity"
}, {
  id: "02",
  title: "Despacho en Terreno",
  description: "Contamos con logística propia para la entrega y retiro de maquinaria pesada directamente en su predio agrícola.",
  iconName: "Headset"
}, {
  id: "03",
  title: "Flota Especializada",
  description: "Tractores de alta potencia y grúas horquilla 4x4 diseñadas para el máximo rendimiento en terrenos difíciles.",
  iconName: "MonitorPlay"
}];
const renderIcon = (name: string) => {
  switch (name) {
    case "Activity":
      return <Activity className="w-6 h-6" />;
    case "Headset":
      return <Headset className="w-6 h-6" />;
    case "MonitorPlay":
      return <MonitorPlay className="w-6 h-6" />;
    default:
      return null;
  }
};
export default function PourquoiChoisirCloudMedia() {
  const {
    ref: leftRef,
    isVisible: isLeftVisible
  } = useRevealOnScroll({
    threshold: 0.2
  });
  const {
    ref: rightRef,
    isVisible: isRightVisible
  } = useRevealOnScroll({
    threshold: 0.2
  });
  return <section data-section-id="224296" id="por-qué-elegir-arrels" className="bg-background text-foreground py-24 lg:py-32 overflow-hidden relative">
      {}
      <div className="absolute top-0 left-1/2 -translate-x-1/2 w-full max-w-3xl h-[500px] bg-primary/10 blur-[120px] rounded-full pointer-events-none" />

      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8 relative z-10">
        <div className="grid grid-cols-1 lg:grid-cols-2 gap-16 lg:gap-24 items-center">
          
          {}
          <div ref={leftRef} className={`relative w-full aspect-square lg:aspect-[4/5] rounded-sm overflow-hidden border border-border/50 shadow-2xl group transition-all duration-1000 ease-out ${isLeftVisible ? "opacity-100 translate-x-0" : "opacity-0 -translate-x-12"}`}>
            {}
            <div className="absolute top-1/2 left-1/2 -translate-x-1/2 -translate-y-1/2 w-3/4 h-3/4 bg-primary/15 blur-[80px] rounded-full pointer-events-none" />
            
            <img src="https://wpvc-images.s3.us-east-1.amazonaws.com/images/1647820/img/arrels_tractor_hydraulic_detail.png" alt="Detalle de maquinaria agrícola Arrels" className="w-full h-full object-cover relative z-10 transition-transform duration-1000 group-hover:scale-105" />
            
            {}
            <div className="absolute inset-0 bg-gradient-to-tr from-background/80 via-transparent to-transparent z-20 pointer-events-none" />
            <div className="absolute inset-0 border border-primary/20 rounded-sm z-30 pointer-events-none" />
          </div>

          {}
          <div ref={rightRef} className={`flex flex-col justify-center transition-all duration-1000 delay-200 ease-out ${isRightVisible ? "opacity-100 translate-x-0" : "opacity-0 translate-x-12"}`}>
            <div className="mb-12">
              <span className="text-primary font-default font-semibold tracking-widest uppercase text-sm mb-3 block">
                Compromiso de Potencia
              </span>
              <h2 className="text-4xl md:text-5xl font-serif font-bold tracking-tighter text-foreground leading-tight uppercase">
                Por qué elegir <br />
                <span className="text-transparent bg-clip-text bg-gradient-to-r from-primary to-primary/70">
                  ARRELS
                </span>
              </h2>
            </div>

            <div className="flex flex-col gap-12 lg:gap-16">
              {pillars.map((pillar, i) => <div key={pillar.id} data-index={i} className="relative pl-6 md:pl-10 group">
                  {}
                  <div className="absolute -top-12 -left-2 md:-left-6 text-[100px] md:text-[120px] font-serif font-bold text-transparent select-none pointer-events-none transition-opacity duration-500 opacity-10 group-hover:opacity-20" style={{
                WebkitTextStroke: "1px var(--color-primary)"
              }} aria-hidden="true">
                    {pillar.id}
                  </div>

                  {}
                  <div className="relative z-10">
                    <div className="flex items-center gap-5 mb-4">
                      <div className="flex-shrink-0 flex items-center justify-center w-14 h-14 rounded-sm bg-primary/10 border border-primary/30 text-primary shadow-lg shadow-primary/5 transition-transform duration-300 group-hover:scale-110 group-hover:bg-primary/20">
                        {renderIcon(pillar.iconName)}
                      </div>
                      <h3 className="text-2xl font-default font-bold tracking-tight text-foreground uppercase">
                        {pillar.title}
                      </h3>
                    </div>
                    <p className="text-muted-foreground leading-relaxed text-lg pl-[76px] font-default">
                      {pillar.description}
                    </p>
                  </div>
                </div>)}
            </div>
          </div>

        </div>
      </div>
    </section>;
}